import * as React from "react"
import "../../assets/scss/App.scss"
import { InvitationType } from "../../api/Invitation/Model/InvitationType"
import ValidateIdentity from "./ValidateIdentity"
import SetupComplete from "./SetupComplete"
import SetPassword from "./SetPassword"
import { toast } from "react-toastify"
import { RouteComponentProps } from "react-router"
import { Subscription } from "rxjs"
import GetInvitationStatus from "../../api/Invitation/GetInvitationStatus"
import InvitationStatusGridRecord from "../../api/InvitationStatus/Model/InvitationStatusGridRecord"
import CheckInactiveURL from "../../api/Invitation/CheckInactiveURL"
import { AppPageWrapper } from "../NavMenu/AppPageWrapper"
import { InvitationStatus } from "../../api/Invitation/Model/InvitationStatus"
import { Home } from "../../config/Routes"

enum InvitationStep {
  default,
  validateIdentity,
  setupComplete,
  setPassword
}

interface InvitationProcessProps extends RouteComponentProps {
  linkId?: string
  show?: boolean
  onInvitationSetupClose?: (hasUpdates: boolean) => void
}

interface InvitationProcessState {
  data?: InvitationStatusGridRecord
  invitationType?: InvitationType
  invitationStep?: InvitationStep
}

export default class InvitationProcess extends React.PureComponent<InvitationProcessProps, InvitationProcessState> {
  subscription?: Subscription
  checkInactiveSubscription?: Subscription
  currentURL: string = window.location.href
  currentPin: string = ""
  currentOutboxAN?: number
  state: InvitationProcessState = { }

  componentDidMount() {
    this.checkInactiveSubscription = CheckInactiveURL(this.currentURL).subscribe(
      inactive => inactive ? this.navigateNotFound() : this.getInvitationStatus(),
      error => toast.error(error)
    )
  }

  componentWillUnmount() {
    this.subscription && this.subscription.unsubscribe()
  }

  navigateNotFound() {
    // TODO: this.router.navigate(['/page-not-found']);
    toast.error("Page not found")
  }

  getInvitationStatus() {
    this.subscription = GetInvitationStatus(this.currentURL).subscribe(
      data => {
        if (!this.currentOutboxAN) {
          this.currentOutboxAN = this.state.data?.OutboxAN
        }
        // if (data.Status === InvitationStatus.COMPLETED || (data.Status === InvitationStatus.USER_CONFIGURED && data.IsUser)) {
        //   this.goToLogin()
        //   return
        // }
        this.setState({
          data: data,
          invitationType: this.mapInvitationType(data),
          invitationStep: this.mapStep(data)
        })
      },
      error => toast.error(error)
    )
  }

  mapInvitationType(status: InvitationStatusGridRecord): InvitationType {
    if (status.IsClinic) {
      return InvitationType.Portal
    }
    if (status.IsClient) {
      return InvitationType.Company
    }
    if (status.IsUser) {
      return InvitationType.User
    }
    if (status.IsLocation) {
      return InvitationType.Location
    }
    if (status.IsConfigurePassword) {
      return InvitationType.ConfigurePassword
    }
    return InvitationType.Unknown
  }

  mapStep(status: InvitationStatusGridRecord): InvitationStep {
    switch (status.Status) {
      case InvitationStatus.INVITATION_REQUESTED:
      case InvitationStatus.INVITATION_STILL_IN_PROCESS:
      case InvitationStatus.INVITATION_IN_USE:
      case InvitationStatus.TOO_MANY_ATTEMPT:
      case InvitationStatus.STARTED:
        return this.currentPin.length ? InvitationStep.setPassword : InvitationStep.validateIdentity
      case InvitationStatus.PASSWORD_SET:
      case InvitationStatus.CLINIC_CONFIGURED:
      case InvitationStatus.COMPLETED:
        return InvitationStep.setupComplete
      default:
        return InvitationStep.validateIdentity
    }
  }

  handleNext() {
    switch (this.state.invitationType) {
      case InvitationType.Portal:
      case InvitationType.Company:
      case InvitationType.Location:
      case InvitationType.User: this.handleNextUser(); break
      case InvitationType.ConfigurePassword: this.handleNextConfigurePassword(); break
    }
  }

  handleNextConfigurePassword() {
    switch (this.state.invitationStep) {
      case InvitationStep.validateIdentity: this.setState({ invitationStep: InvitationStep.setPassword }); break
      case InvitationStep.setPassword: this.goToLogin(); break
    }
  }

  handleNextUser() {
    switch (this.state.invitationStep) {
      case InvitationStep.validateIdentity: this.setState({ invitationStep: InvitationStep.setPassword }); break
      case InvitationStep.setPassword: this.setState({ invitationStep: InvitationStep.setupComplete }); break
      case InvitationStep.setupComplete: this.goToLogin(); break
    }
  }

  goToLogin = () => (this.props as RouteComponentProps).history.push(Home)

  setupCompleteTitle() {
    switch (this.state.invitationType) {
      case InvitationType.Portal: return "Portal"
      case InvitationType.Company: return "Company"
      case InvitationType.User: return "User"
    }
    return ""
  }

  render() {
    if (!this.props.show || !this.state.data) {
      return <></>
    }
    const { invitationStep } = this.state
    const userName = this.state.data.UserName

    const url = `${window.location.hostname}${window.location.port ? `:${window.location.port}` : ""}${window.location.pathname}#/workforce-login`


    return (<AppPageWrapper>
      { invitationStep === InvitationStep.validateIdentity && <ValidateIdentity
        currentURL={this.currentURL}
        data={this.state.data}
        status={this.state.data.Status}
        userPhoneNumber={this.state.data.ContactDetail}
        userEmail={this.state.data.UserName}
        onSuccess={(pin: string, outboxAN: number) => { this.currentPin = pin; this.currentOutboxAN = outboxAN; this.handleNext() }} />}
      { invitationStep === InvitationStep.setPassword && this.currentOutboxAN &&
        <SetPassword userName={userName} PIN={this.currentPin} OutboxAN={this.currentOutboxAN} onSave={() => this.handleNext()} />}
      { invitationStep === InvitationStep.setupComplete && <SetupComplete onNext={() => this.handleNext()} url={url} title={`${this.setupCompleteTitle()} Setup`} />}
    </AppPageWrapper>)
  }

  static defaultProps = {
    show: true
  }
}
